<!-- Artifact Config Panel - Compact layout with tree dropdown and collapsible sections -->
<div class="config-panel config-panel--compact">
  <!-- Artifact Selection (Primary) -->
  <div class="form-group">
    <label>
      <i class="fa-solid fa-cube"></i>
      Select Artifact
      <span class="required">*</span>
    </label>
    <mj-tree-dropdown
      #artifactDropdown
      [BranchConfig]="CollectionConfig"
      [LeafConfig]="ArtifactLeafConfig"
      [Value]="ArtifactIdAsKey"
      [SelectableTypes]="'leaf'"
      [SelectionMode]="'single'"
      [Placeholder]="'Search or browse artifacts...'"
      [EnableSearch]="true"
      (SelectionChange)="onArtifactSelection($event)"
      [class.error]="artifactError">
    </mj-tree-dropdown>
    @if (artifactError) {
      <span class="form-error">{{ artifactError }}</span>
    }
    @if (!artifactError && !artifactId) {
      <span class="form-hint">
        Browse collections or search to find an artifact
      </span>
    }
    @if (!artifactError && artifactId) {
      <span class="form-hint form-hint--selected">
        <i class="fa-solid fa-check"></i>
        Selected: {{ artifactName }}
      </span>
    }
  </div>

  <!-- Version Selection (Available only after artifact is selected) -->
  @if (artifactId) {
    <div class="form-group">
      <label for="versionSelect">
        <i class="fa-solid fa-code-branch"></i>
        Version
      </label>
      <div class="version-select-wrapper">
        @if (!isLoadingVersions && versions.length > 0) {
          <select
            id="versionSelect"
            [(ngModel)]="versionNumber"
            (change)="onVersionChange()"
            class="form-select">
            @for (v of versions; track v) {
              <option [ngValue]="v.VersionNumber">
                v{{ v.VersionNumber }} - {{ v.__mj_CreatedAt | date:'short' }}
              </option>
            }
          </select>
        }
        @if (isLoadingVersions) {
          <span class="form-hint">
            <i class="fa-solid fa-spinner fa-spin"></i>
            Loading versions...
          </span>
        }
        @if (!isLoadingVersions && versions.length === 0) {
          <span class="form-hint">
            No versions available
          </span>
        }
      </div>
      @if (versions.length > 0) {
        <span class="form-hint">
          Select which version to display (latest is default)
        </span>
      }
    </div>
  }

  <!-- Title (Optional) -->
  <div class="form-group">
    <label for="partTitle">
      <i class="fa-solid fa-heading"></i>
      Part Title
      <span class="optional-tag">(optional)</span>
    </label>
    <input
      type="text"
      id="partTitle"
      [(ngModel)]="title"
      (input)="onTitleChange()"
      [placeholder]="artifactName ? 'Default: ' + artifactName : 'Enter a custom title'"
      class="form-input">
    <span class="form-hint">Leave empty to use artifact name as title</span>
  </div>

  <!-- Display Options -->
  <mj-accordion-panel [(Expanded)]="showOptions" Size="sm">
    <ng-template mjAccordionTitle>
      <i class="fa-solid fa-sliders"></i>
      Display Options
    </ng-template>
    <div class="config-section-body">
      <div class="checkbox-group checkbox-group--compact">
        <label class="checkbox-option checkbox-option--compact">
          <input
            type="checkbox"
            [(ngModel)]="showHeader"
            (change)="onOptionChange()">
          <span class="checkbox-mark"></span>
          <span class="checkbox-label">Show Header</span>
        </label>
        <label class="checkbox-option checkbox-option--compact">
          <input
            type="checkbox"
            [(ngModel)]="showTabs"
            (change)="onOptionChange()">
          <span class="checkbox-mark"></span>
          <span class="checkbox-label">Show Tabs</span>
        </label>
        <label class="checkbox-option checkbox-option--compact">
          <input
            type="checkbox"
            [(ngModel)]="showMetadata"
            (change)="onOptionChange()">
          <span class="checkbox-mark"></span>
          <span class="checkbox-label">Show Metadata</span>
        </label>
      </div>
    </div>
  </mj-accordion-panel>
</div>
